module.exports = __webpack_public_path__ + "img/text-annotation.926416f4.svg";